import moment from 'moment'
import { Http } from '../../../helpers/axois'
import { IResourceApp, IRule } from './type'
import { GCPENDPOINT } from '../../../constant/common' 

export const appMapper = (app: IResourceApp) => {
  const {
    id,
    name,
    created_by,
    created_at,
    description,
    support_email,
    author_website,
    is_installed,
    version_tag,
    object_url,
    screenshots,
    avatar,
    release_notes,
    updated_at,
  } = app

  const { first_name, last_name } = created_by
  const createdAt = moment(created_at).format('DD MMM YYYY')
  const updatedAt = moment(updated_at).format('DD MMM YYYY')

  return {
    id,
    name,
    description: description || '',
    createdBy: {
      id: created_by.id,
      firstName: first_name,
      lastName: last_name || '',
    },
    createdAt,
    updatedAt,
    supportEmail: support_email || '',
    authorWebsite: author_website || '',
    isInstalled: is_installed,
    currentVersion: version_tag,
    objectUrl: object_url,
    avatar,
    screenshots,
    releaseNotes: release_notes,
  }
}

export const getFilename = (url: string) => {
  const tokens = url.split("/")
  return tokens[tokens.length - 1]
}

export const deleteImage = async (url: string, orgId: string) => {
  const endpoint = `/orgs/${orgId}/marketplaceApps/image/remove`

  const filePath = new URL(url).pathname; 
  const body = {
    data: {
      files: {
        fileName: filePath
      }
    }
  }

  try {
    await Http.put(endpoint, body).toPromise()
  } catch(err) {
    var msg = err?.message || 'Failed to delete image'
    if (err === "Forbidden") {
      msg = 'Not Authorized: Please request owner of this organization to provide access'
    }
    throw new Error(msg)
  }
}

export const validateRule = (rule: IRule, resource: any) => {
  let errorMessage = ""
  const resourceKeys = Object.keys(resource)

  // the good ol' for loop
  for(let i = 0; i < resourceKeys.length; i++) {
    const key = resourceKeys[i]
    if(!rule.hasOwnProperty(key)) {
      continue
    }

    const resourceVal = resource[key]
    const ruleVal = rule[key]

    if(ruleVal.type === "string" && !resourceVal.trim()) {
      errorMessage = ruleVal.message
      break
    }

    if(ruleVal.type === "string" && ruleVal.min) {
      const limit = ruleVal.min.limit
      if(resourceVal.trim().length < limit) {
        errorMessage = ruleVal.min.message
        break
      }
    }

    if(ruleVal.type === "string" && ruleVal.max) {
      const limit = ruleVal.max.limit
      if(resourceVal.trim().length > limit) {
        errorMessage = ruleVal.max.message
        break
      }
    }
  }

  return errorMessage
}

export const validateFile = (file: File, rules: {
  size?: number
  mimeType?: string[]
  type: "artifact" | "image" | "file"
}) => {
  let errMsg = ""
  const sizeInMB = file.size / (1024 * 1024)
  const { size, type, mimeType } = rules

  if(size && sizeInMB > size) {
    errMsg = `Please upload ${type} smaller than ${size}MB`
  }

  if(mimeType && !mimeType.includes(file.type)) {
    errMsg = `The file type ${file.type} is not supported`
  }

  return errMsg
}
export const isValidFuncName = (funcName: string): boolean => {
  const regex = /^[a-zA-Z_$][0-9a-zA-Z_$]*$/;
  return regex.test(funcName);
}

export function rgbToHex(r: any, g: any, b: any, a: any = 1) {
  const red = parseInt(r, 10) || 0;
  const green = parseInt(g, 10) || 0;
  const blue = parseInt(b, 10) || 0;
  const alpha = parseFloat(a);

  const validRed = Math.min(255, Math.max(0, red));
  const validGreen = Math.min(255, Math.max(0, green));
  const validBlue = Math.min(255, Math.max(0, blue));
  const validAlpha = Math.min(1, Math.max(0, alpha));

  const hexRed = validRed.toString(16).padStart(2, '0');
  const hexGreen = validGreen.toString(16).padStart(2, '0');
  const hexBlue = validBlue.toString(16).padStart(2, '0');
  const hexAlpha = Math.round(validAlpha * 255).toString(16).padStart(2, '0');

  return `#${hexRed}${hexGreen}${hexBlue}${hexAlpha}`;
}
